import { render, staticRenderFns } from "./MessagesModal.vue?vue&type=template&id=823dd4ee&scoped=true&"
import script from "./MessagesModal.vue?vue&type=script&lang=js&"
export * from "./MessagesModal.vue?vue&type=script&lang=js&"
import style0 from "./MessagesModal.vue?vue&type=style&index=0&id=823dd4ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823dd4ee",
  null
  
)

export default component.exports